<template>
    <div>
        <v-layout>
            <template v-for="item, index in statuses">
                <v-btn :key="index" @click="filter.status = item.value, search(true)">{{ item.name }}</v-btn>
            </template>
        </v-layout>

        <v-row>
            <template v-for="application, index in applications">
                <v-col cols="3" :key="index">
                    <v-sheet color="grey lighten-2" @click="$router.push(`/developer/kea/applications/` + application._id)" style="cursor: pointer">
                        <v-img v-if="application.thumb" :src="application.thumb.src" width="100%" height="396" contain />

                        <div>
                            <b>제목: {{ application.subject }}</b>
                        </div>
                        
                        <div v-if="application.status == '모집중'">★★모집중★★</div>
                        <div v-if="application.status == '모집 종료'">♧♧모집 종료♧♧</div>

                        <!-- 관리자 작성 항목-->
                        <ul>
                            <template v-for="item, index in application.items">
                                <li :key="index">
                                    <b v-html="item.title.replace(/\n/g, '<br/>')" class="d-inline" /> : 
                                    <p v-html="item.txt.replace(/\n/g, '<br/>')" class="d-inline ma-0" />
                                </li>
                            </template>
                        </ul>

                        <!-- 문의처 항목-->
                        <ul>
                            <template v-for="item, index in application.helpItems">
                                <li :key="index">
                                    <b v-html="item.title.replace(/\n/g, '<br/>')" class="d-inline" /> : 
                                    <p v-html="item.txt.replace(/\n/g, '<br/>')" class="d-inline ma-0" />
                                </li>
                            </template>
                        </ul>
                    </v-sheet>
                </v-col>
            </template>
        </v-row>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
    </div>
</template>

<script>
import api from "@/api";

const statuses = [
    { name: "전체", value: null },
    { name: "모집중", value: "모집중" },
    { name: "모집 종료", value: "모집 종료" },
];

export default {
    data(){
        return {
            statuses,

            filter: {
                status: this.$route.query.status || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0, // 페이징 분할 크기
            limit: 8, // n개 만큼 게시글 가져오기
            summary: { totalCount: 0 },
            applications: [],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },

        async search(routable = false){

            // 페이징 or 필터 변경시 라우터 기록 -> 뒤로가기시 이전 라우터로 복귀
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, applications } = await api.v1.kea.applications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.applications = applications;
        }
    }
}
</script>